const formatter = new Intl.NumberFormat();

export const formatPrice = (price) => {
  if (price === null || price === undefined) return 'N/A';
  return formatter.format(Math.round(parseFloat(price))) + ' ISK';
};

const centsFormatter = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Per-unit prices: cheap items (ammo, minerals) keep their cents, where rounding would hide the margin.
export const formatUnitPrice = (price) => {
  if (price === null || price === undefined) return 'N/A';
  const value = parseFloat(price);
  return Math.abs(value) < 100 ? `${centsFormatter.format(value)} ISK` : formatPrice(value);
};
